<div
  class="lds-ring"
  [ngStyle]="{ height: spinnerSize() }"
>
  <div [ngStyle]="{ 'border-left-color': color(), 'border-width': borderWidth() }"></div>
  <div [ngStyle]="{ 'border-left-color': color(), 'border-width': borderWidth() }"></div>
  <div [ngStyle]="{ 'border-left-color': color(), 'border-width': borderWidth() }"></div>
  <div [ngStyle]="{ 'border-left-color': color(), 'border-width': borderWidth() }"></div>
</div>
